var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScratchedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 149,
    viewBox: "0 0 394 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_485_1625)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M-76.21 122.066L-42.8337 130.184C-9.45743 138.301 57.2951 154.536 124.048 146.419C190.8 138.301 257.553 105.831 324.305 85.5367C391.058 65.2427 457.81 57.1251 524.563 57.1251C591.315 57.1251 658.068 65.2427 691.444 69.3015L724.82 73.3603",
    stroke: "url(#paint0_radial_485_1625)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M-76.21 58.5719L-42.8337 66.6895C-9.45743 74.8071 57.2951 91.0423 124.048 82.9247C190.8 74.8071 257.553 42.3367 324.305 22.0427C391.058 1.7487 457.81 -6.3689 524.563 -6.3689C591.315 -6.3689 658.068 1.7487 691.444 5.8075L724.82 9.86631",
    stroke: "url(#paint1_radial_485_1625)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M-76.21 90.3189L-42.8337 98.4365C-9.45743 106.554 57.2951 122.789 124.048 114.672C190.8 106.554 257.553 74.0837 324.305 53.7897C391.058 33.4956 457.81 25.3781 524.563 25.3781C591.315 25.3781 658.068 33.4957 691.444 37.5545L724.82 41.6133",
    stroke: "url(#paint2_radial_485_1625)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_485_1625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(324.305 102.878) rotate(90) scale(45.753 400.515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2262ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2262ED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_485_1625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(324.305 39.3841) rotate(90) scale(45.753 400.515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2262ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2262ED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_485_1625",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(324.305 71.132) rotate(162.216) scale(327.104 18253.8)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2262ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2262ED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_485_1625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393.92,
    height: 148.631,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScratchedIcon);
export default __webpack_public_path__ + "static/media/scratched_icon.ae3450691b514a7bea5d51a2c25e3665.svg";
export { ForwardRef as ReactComponent };